<template>
  <div>
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="query"
              type="search"
              :placeholder="'Search here...'"
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l("INDEX.advanced_search") || "高级搜索" }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="add"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{$l('btn_create_project') || '创建项目'}}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="medium">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('label_search_prjTitle') || '项目名称'">
              <el-input
                v-model="form.prjTitle"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('label_search_customer') || '客户'">
              <dict-select
                style="width: 100%"
                clearable
                filterable
                v-model="form.custCode"
                url="/digitalCenter/common/dict/customer"
                size="small"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              >
              </dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('label_search_category') || '所属分类'">
              <dict-select
                clearable
                filterable
                style="width: 100%"
                v-model="form.prjCategoryCode"
                size="small"
                url="/digitalCenter/common/dict/prjCategory"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('label_search_status') || '状态'">
              <dict-select
                clearable
                filterable
                style="width: 100%"
                v-model="form.prjStatus"
                size="small"
                url="/digitalCenter/common/dict/system"
                :body="{ dictType: 'prjStatus' }"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('label_search_modify_date_start') || '起始日期'"
            >
              <el-date-picker
                v-model="form.modifyDateStart"
                type="date"
                :placeholder="
                  $l('label_search_modify_date_start') || '起始日期'
                "
                style="width: 100%"
                size="small"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('label_search_modify_date_end') || '截止日期'"
            >
              <el-date-picker
                v-model="form.modifyDateEnd"
                type="date"
                :placeholder="$l('label_search_modify_date_end') || '截止日期'"
                style="width: 100%"
                size="small"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l("INDEX.btn_cancel_query") || "取消查询"
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l("INDEX.btn_reset_filter ") || "重置条件"
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l("INDEX.btn_data_retrieval") || "数据检索"
        }}</el-button>
      </span>
    </el-dialog>

    <add-project ref="addProject" />
  </div>
</template>

<script>
import AddProject from "../add";

const initForm = {
  searchKey: "",
  prjTitle: "",
  prjCategoryCode: "",
  custCode: "",
  prjStatus: "",
  prjStatusList: [],
  modifyDateStart: "",
  modifyDateEnd: "",
};

export default {
  components: {
    AddProject,
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: {
        ...initForm,
      },
    };
  },
  methods: {
    add() {
      let val = {
        formTitle: this.$l("INDEX.label_title_add_project") || "新增项目",
      };
      this.$refs.addProject.fromLoad("add", val);
      return;
    },
    query() {
      this.form.prjStatusList = [];
      if (this.form.prjStatus) {
        this.form.prjStatusList.push(this.form.prjStatus);
      }
      this.$emit("submit", this.form);
    },
    // 高级查询
    advquery() {
      this.form.searchKey = "";
      this.query();
      this.closeAdvqueryDialog();
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm };
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true;
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false;
    },
  },
  mounted() {
    this.query();
  },
  activated() {
    this.query();
  },
};
</script>
